import React, { Component, useCallback, useMemo, useState } from "react";
import { ButtonBase, Checkbox, CircularProgress } from "@material-ui/core";
import styles from "./Style.module.css";
import Constants from "../../../../../config/constants";
import Datatables from "../../../../../components/Datatables/datatables";
import FilterComponent from "../../../../../components/Filter/Filter.component";
import useCoAdminHook from "./CoAdmin.hook";

const CoAdminView = ({
  empList,
  groupId,
  coAdminIds,
  handleUpdateGroup,
  handleClosepopOver,
  fetchChatInfo,
  renderConversation
}) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    handleRowSelection,
    handleEdit,
    handleFilterDataChange,
    handleSearchValueChange,
    handleViewDetails,
    isCalling,
    handleCheckbox,
    selected,
    data,
    currentData,
    currentPage,
    isFetching,
    selectAllEmployee,
    handleAddCoAdmin,
    loading,
  } = useCoAdminHook({
    empList,
    groupId,
    handleUpdateGroup,
    handleClosepopOver,
    coAdminIds,
    fetchChatInfo,
    renderConversation
  });

  const renderFirstCell = useCallback(
    (data) => {
      const selectedIndex = selected.findIndex((sel) => sel.id === data.id);
      return (
        <div className={styles.flex}>
          <Checkbox
            disabled={false}
            onChange={() => handleCheckbox(data)}
            checked={selectedIndex >= 0}
            value="secondary"
            className={styles.checkBoxClass}
          />
          <div>
            {data?.name}
            <br />
            {data?.emp_code}
          </div>
        </div>
      );
    },
    [handleCheckbox, selected]
  );

  const tableStructure = useMemo(() => {
    return [
      {
        key: "check",
        label: (
          <div className={styles.flex}>
            <div className={styles.selectallCheckbox}>
              {/* <Checkbox
                onChange={(e) => {
                  selectAllEmployee(e);
                }}
                checked={data?.length > 0 && data?.length === selected?.length}
                value="secondary"
                className={styles.checkBoxClass}
              /> */}
            </div>

            <div>Employee</div>
          </div>
        ),
        sortable: false,
        render: (value, all) => <div>{renderFirstCell(all)}</div>,
      },
      {
        key: "designation",
        label: "DESIGNATION",
        sortable: false,
        render: (temp, all) => <div>{all?.designation?.name}</div>,
      },

      {
        key: "location",
        label: "LOCATION",
        sortable: false,
        render: (temp, all) => <div>{all?.location?.name}</div>,
      },
      {
        key: "department",
        label: "DEPARTMENT",
        sortable: false,
        render: (temp, all) => <div>{all?.department?.name}</div>,
      },
    ];
  }, [renderFirstCell, handleViewDetails, handleEdit, isCalling]);

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSelection: handleRowSelection,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      // allRowSelected: true,
      // showSelection: true,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    data,
    currentPage,
    currentData,
  ]); // allData,

  return (
    <div className={styles.sliderWrapper}>
      <div className={styles.sliderWrapperContainer}>
        <div>
          <FilterComponent
            is_progress={isFetching}
            filters={[]}
            handleSearchValueChange={handleSearchValueChange}
            handleFilterDataChange={handleFilterDataChange}
            placeholder={"Search by employee name or code"}
          />
          {/* <div className={styles.isMobileCheckbox}>
            <Checkbox
              onChange={(e) => {
                selectAllEmployee(e);
              }}
              checked={data?.length > 0 && data?.length === selected?.length}
              value="secondary"
              className={styles.checkBoxClass}
            />
            Select All Employee
          </div> */}
          <Datatables
            {...tableData.datatable}
            {...tableData.datatableFunctions}
          />
        </div>
        <div className={styles.stickBottom}>
          <div className={styles.RequestShortlistWrapper}>
            <div className={styles.btnWrap}>
              <div className={styles.heading3}>
                {selected?.length}{" "}
                {`${selected?.length > 1 ? "Employees" : "Employee"}`} Selected
              </div>
            </div>
            <div>
              <ButtonBase
                disabled={loading}
                onClick={() => {
                  handleAddCoAdmin();
                }}
                className={styles.createBtn}
              >
                {loading ? (
                  <CircularProgress color="success" size="20px" />
                ) : (
                  "ADD"
                )}
              </ButtonBase>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoAdminView;
